define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/Deferred",
	"dojo/when",
	"dijit/layout/ContentPane",
	"csi",
	"csi/_base/Deferred",
	"csi/_base/underscore",
	"csi/def",
	"csi/html",
	"csi/locale"
], function(declare, lang, Deferred, when, ContentPane, csi, csiDeferred, _, def, html, locale) {

	return declare(ContentPane, {
		// Tab: view reference
		defTab: null,

		// String: url for root node for tab's view
		urlRootNode: null,

		// csi.view.Widget: view for tab
		viewTab: null,

		// Boolean: force query to get root node of view - tab views query for them all at once, so
		// should not have to force to get one by one
		_bForceRootNode: false,

		// Boolean: indicate if tabs should be tested for access (true for tabs view, but false for wizard view)
		_bTestViewAccess: true,

		canBeSelected: function() {
			// summary: indicate if view can be selected
			return this.controlButton ? html.isVisible(this.controlButton.domNode) : false;
		},

		destroy: function() {
			// summary: reset pointer just to be sure no more references to view
			this.viewTab = null;
			this.inherited(arguments);
		},

		getLocation: function() {
			// summary: get document location for tab
			return this.defTab.m_idView;
		},

		getLocationName: function() {
			// summary: return string used in document title for this tab
			return _.unescape(this.get("title"));
		},

		createView: function(/*csi.tabs.Widget*/tabsView, /*Boolean*/bRefresh) {
			// summary: create and return view for tab if visible
			const {domNode, urlRootNode, viewTab} = this;
			let dfd;
			let dfdNode;

			if (!viewTab) {
				// create and render the view
				dfd = new csiDeferred();
				var cacheView = tabsView.cacheView;
				var rootNode = cacheView.get(urlRootNode) || tabsView.getViewNode();
				// if view is not in the cache - request it
				if (!rootNode) {
					dfdNode = cacheView.getNodeDeferred(urlRootNode);
				} else {
					// view was found in the cache - just create dummy defereds
					dfdNode = new csiDeferred();
					dfdNode.resolve(rootNode);
				}
				tabsView.when(dfdNode, (rootNode) => {
					const tabLocationType = tabsView.getTabLocationType();
					var dfdView = tabsView._insertView(this._getViewDef(rootNode, tabLocationType), rootNode);
					if (dfdView) {
						when(dfdView, lang.hitch(this, this._onInsertView, tabsView, dfd));
					} else {
						// if view can't be created - just resolve deferreds to let it go
						dfd.resolve();
					}
				})
			} else if (!viewTab.isStarted()) {
				// render the view
				dfd = viewTab.placeAt(domNode).startup();
			} else {
				// notify views when tab becomes visible, and resize in case window changed sizes while tab was hidden
				if (viewTab.bViewed) {
					viewTab.onTabSwitch();
					viewTab.traverseViews((v) => {
						v.onTabSwitch();
						return true;
					});
					viewTab.resize();
				}

				dfd = new Deferred();
				dfd.resolve(viewTab);
			}

			if (dfd && tabsView.bPopup) {
				dfd.then(function() {
					var domNodes = $(tabsView.tabsNode.domNode).find('.dijitTabPaneWrapper');
					if (domNodes.length) {
						html.freezeDomNode(domNodes[0], false);
					}
				});
			}

			return dfd;
		},

		refreshTab: function(/*Context*/ctx) {
			// summary: update tab based on new context
			const tabLocationType = ctx.view.getTabLocationType();
			var rootNode = this.defTab.getRootNode(ctx, this._bForceRootNode);
			var type = rootNode ? rootNode.$Type : this.defTab.target;
			var idView = this.getLocation();
			var idType = this._getViewDef(rootNode, tabLocationType, true);
			var name = locale.getResolver({typeContext: type}).getTypeView(type, idView);
			var bView = idType
				&& def.processRules(ctx, this.defTab.m_rules)
				&& this._processAccessTab(ctx, this.defTab);

			this.urlRootNode = rootNode ? rootNode.$URL : null;

			// set name of tab by setting ContentPane title so that overflow drop-down of tabs shows labels
			this.set("title", _.escape(name));

			// DOJO INTERNAL: update visibility of tab, and set label directly on tab button to handle case
			// where startup is already called
			if (this.controlButton) {
				// we handle the key press event in home.js, in this case, just let it go, the view will take over */
				this.controlButton.set("csiIgnoreKeyPress", false);
				this.controlButton.set("label", _.escape(name));
				this.controlButton.set("data-csi-tab", def.getHtmlViewKey(idType, idView));
				html.setVisible(this.controlButton.domNode, bView);
			}

			if (this.viewTab) {
				// if view already exists and is still valid, then reset root node; otherwise, destroy view
				// so it can be recreated later
				if (bView && (this.viewTab.defView.m_idType == idType)) {
					if (rootNode) {
						this.viewTab.setViewNode(rootNode);
					}
				} else {
					this.viewTab.destroyView();
					this.viewTab = null;
				}
			}

			return this.viewTab;
		},

		_getRootClass: function() {
			// summary: return reflection class that holds view for tab
			return this.defTab.getRootNodeClass();
		},

		_getViewDef: function(/*Node*/rootNode, /*String?*/locationType, /*Boolean?*/bCheckOnly) {
			// summary: find the view definition for tab
			var id = this.getLocation();
			var defView = rootNode ? def.getNodeViewDef(rootNode, id, this._bTestViewAccess, bCheckOnly, null, locationType) : null;
			if (defView == null) {
				// try to find the view without using the current node - it could be a case with 'New' action or switchboard
				var rc = this._getRootClass();
				if (rc) {
					defView = def.getClassViewDef(rc, id, this._bTestViewAccess, bCheckOnly);
				}
			}

			return defView;
		},

		_onInsertView: function(/*csi.tabs.Widget*/tabsView, /*Deferred*/dfd, /*csi.view.Widget?*/view) {
			// summary: start loading view for tab
			if (this.viewTab = view) {
				if (this.defTab.bReadOnly) {
					view.defView.setReadOnly(true);
				}

				var s = this.defTab.switchboard;
				if (s) {
					view.addSwitchboard(s);
				}

				when(view.placeAt(this.domNode).startup(), function() {
					// resolve deferred only after view is loaded
					dfd.resolve(view);
				});
			} else {
				dfd.resolve();
			}
		},

		_processAccessTab: function(/*Context*/ctx, /*Tab*/defTab) {
			// summary: invokes the AccessTab optional attribute defined on ViewRef element. If returns true
			// then it will render the Tab and what's inside it. Otherwise it won't.
			if (!defTab.accessTab) {
				return true;
			}

			const func = csi.resolveFunction(defTab.accessTab);
			return func ? func(ctx.getNode(), ctx.cache) : false;
		}
	});
});